export default {
  'PageSearchInput.HeaderWrapper.LeftSideWrapper.Input': ({ value, showDropdown }, outlet, internalStateSetter) => {
    outlet({ action: 'change', searchTerm: value });
    if (value.length > 1 && showDropdown) {
      internalStateSetter({ isOpen: true });
    } else {
      internalStateSetter({ isOpen: false })
    }
  },
  'PageSearchInput.HeaderWrapper.LeftSideWrapper.Input(Keydown)': ({ value, key }, outlet, internalStateSetter) => {
    if (key === 'Enter') {
      outlet({ action: 'set', searchTerm: value })
      internalStateSetter({ inputVal: '', isOpen: false });
    }
  },
  'PageSearchInput.HeaderWrapper.Button': ({ inputVal }, outlet, internalStateSetter) => {
    outlet({ action: 'set', searchTerm: inputVal })
    internalStateSetter({ inputVal: '', isOpen: false });
  },
  'PageSearchInput.DropdownWrapper.BorderWrapper.BodyWrapper.Body.Row': ({ suggestion }, outlet, internalStateSetter) => {
    internalStateSetter({ inputVal: '', isOpen: false });
    outlet({ action: 'set', searchTerm: suggestion })
  },
  'PageSearchInput.HeaderWrapper.LeftSideWrapper.SearchTerm': ({ }, outlet) => {
    outlet({ action: 'set', searchTerm: '' })
  },
  'PageSearchInput.DropdownWrapper.BorderWrapper.BodyWrapper.Body.RecentSearchRow': ({ suggestion }, outlet, internalStateSetter) => {
    internalStateSetter({ inputVal: '', isOpen: false });
    outlet({ action: 'set', searchTerm: suggestion })
  },
  'PageSearchInput.HeaderWrapper': ({ searchTerm }, outlet) => {
    if (searchTerm) {
      outlet({ action: 'set', searchTerm: '' });
      outlet({ action: 'change', searchTerm });
    }
  }
};
